import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const deleteMandatedClasses = (classid, usergroupid) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.ADMIN.GROUP_MANAGEMENT.DELETE_MANDATED_CLASSES(
      classid,
      usergroupid
    )
  );
};

export default deleteMandatedClasses;
